module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/f0857ad2ad70a026a72556e288dc5d72.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend5.svg
// module id = C97H
// module chunks = 1